import filterFunction from "../../utilityFunctions/filterFunction";
import { FILTER_BY } from "../filter/actionTypes";

const filterMiddleware = store => next => action => {
    if (action.type === FILTER_BY) {
        console.log("filter", action);
        const { posts, filter } = store.getState();
        const filterProperty = getFilterProperty(filter, action.payload)
        const filteredPosts = filterFunction(posts, { ...filter, ...filterProperty })
        const payload = { type: action.payload.type, value: filterProperty[action.payload.type], posts: filteredPosts }
        next({ ...action, payload })
    } else {
        next(action);
    }
}

function getFilterProperty(currentProperty, newProperty) {
    if (typeof currentProperty[newProperty.type] === "object") {
        let newValue = currentProperty[newProperty.type];
        console.log("file: filterMiddleware.js ~ line 21 ~ getFilterProperty ~ newValue", newValue)
        if (newValue.includes(newProperty.value)) {
            newValue = newValue.filter(item => item !== newProperty.value);
        } else {
            newValue.push(newProperty.value)
        }
        console.log("file: filterMiddleware.js ~ line 21 ~ getFilterProperty ~ newValue", newValue)
        return { [newProperty.type]: newValue }
    }
    return { [newProperty.type]: newProperty.value }

}
export default filterMiddleware;